import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../_db";
import { useLanguage } from "@/contexts/LanguageContext";

interface WaterSourcesData {
  sources: {
    en: string[];
    pt: string[];
  };
}

export const useWaterSources = () => {
  const { language } = useLanguage();
  const [waterSources, setWaterSources] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, "settings", "water_sources"),
      (snapshot) => {
        try {
          if (snapshot.exists()) {
            const data = snapshot.data() as WaterSourcesData;
            const sources = data.sources?.[language] || [];
            setWaterSources(sources);
          } else {
            setWaterSources([]);
          }
          setLoading(false);
        } catch (err) {
          setError(err as Error);
          setLoading(false);
        }
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [language]);

  return { waterSources, loading, error };
};
